module.exports = __webpack_public_path__ + "static/img/pro2.405a908d.png";